import { render } from "./createMemo.vue?vue&type=template&id=6ed36c70&scoped=true"
import script from "./createMemo.vue?vue&type=script&lang=js"
export * from "./createMemo.vue?vue&type=script&lang=js"

import "./createMemo.vue?vue&type=style&index=0&id=6ed36c70&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed36c70"]])

export default __exports__